// eslint-disable-next-line import/prefer-default-export
export function parseMessage(e) {
  let message = 'Erro não especificado';

  if (e) {
    if (typeof e === 'string') {
      message = e || message;
    } else if (e.response?.data?.message) {
      ({ message } = e.response.data);
    } else if (e.message) {
      ({ message } = e);
    }
  }

  return message;
}
